/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRemoteMcpServerHeadersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRemoteMcpServerHeadersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRemoteMcpServerHeadersSecurity = {
  option1?: ListRemoteMcpServerHeadersSecurityOption1 | undefined;
  option2?: ListRemoteMcpServerHeadersSecurityOption2 | undefined;
};

export type ListRemoteMcpServerHeadersRequest = {
  /**
   * The ID of the remote MCP server
   */
  remoteMcpServerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRemoteMcpServerHeadersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRemoteMcpServerHeadersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRemoteMcpServerHeadersSecurityOption1$Outbound,
    ListRemoteMcpServerHeadersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRemoteMcpServerHeadersSecurityOption1ToJSON(
  listRemoteMcpServerHeadersSecurityOption1:
    ListRemoteMcpServerHeadersSecurityOption1,
): string {
  return JSON.stringify(
    ListRemoteMcpServerHeadersSecurityOption1$outboundSchema.parse(
      listRemoteMcpServerHeadersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRemoteMcpServerHeadersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRemoteMcpServerHeadersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRemoteMcpServerHeadersSecurityOption2$Outbound,
    ListRemoteMcpServerHeadersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRemoteMcpServerHeadersSecurityOption2ToJSON(
  listRemoteMcpServerHeadersSecurityOption2:
    ListRemoteMcpServerHeadersSecurityOption2,
): string {
  return JSON.stringify(
    ListRemoteMcpServerHeadersSecurityOption2$outboundSchema.parse(
      listRemoteMcpServerHeadersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRemoteMcpServerHeadersSecurity$Outbound = {
  Option1?: ListRemoteMcpServerHeadersSecurityOption1$Outbound | undefined;
  Option2?: ListRemoteMcpServerHeadersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRemoteMcpServerHeadersSecurity$outboundSchema: z.ZodMiniType<
  ListRemoteMcpServerHeadersSecurity$Outbound,
  ListRemoteMcpServerHeadersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRemoteMcpServerHeadersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRemoteMcpServerHeadersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRemoteMcpServerHeadersSecurityToJSON(
  listRemoteMcpServerHeadersSecurity: ListRemoteMcpServerHeadersSecurity,
): string {
  return JSON.stringify(
    ListRemoteMcpServerHeadersSecurity$outboundSchema.parse(
      listRemoteMcpServerHeadersSecurity,
    ),
  );
}

/** @internal */
export type ListRemoteMcpServerHeadersRequest$Outbound = {
  remote_mcp_server_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRemoteMcpServerHeadersRequest$outboundSchema: z.ZodMiniType<
  ListRemoteMcpServerHeadersRequest$Outbound,
  ListRemoteMcpServerHeadersRequest
> = z.pipe(
  z.object({
    remoteMcpServerId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteMcpServerId: "remote_mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRemoteMcpServerHeadersRequestToJSON(
  listRemoteMcpServerHeadersRequest: ListRemoteMcpServerHeadersRequest,
): string {
  return JSON.stringify(
    ListRemoteMcpServerHeadersRequest$outboundSchema.parse(
      listRemoteMcpServerHeadersRequest,
    ),
  );
}
